import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { EquipmentUseCase } from '/src/lib/models/EquipmentUseCase';

export class EquipmentUseCaseService {
  /**
   * List Equipment Use Cases
   * @returns EquipmentUseCase[]
   * @throws ApiError
   */
  public static listEquipmentUseCases(): CancelablePromise<EquipmentUseCase[]> {
    return __request(OpenAPI, { method: 'GET', url: '/equipmentUseCases' });
  }
}
